import { createGlobalStyle } from "styled-components"

const normalize = `
  /*! modern-normalize | MIT License | https://github.com/sindresorhus/modern-normalize */html{box-sizing:border-box}*,::after,::before{box-sizing:inherit}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}hr{height:0}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bold}code,kbd,pre,samp{font-family:SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{padding:0}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}
`

const GlobalStyles = createGlobalStyle`
  ${normalize};

  html {
    color: ${({ theme }) => theme.color.black};
    scroll-behavior: smooth;
    font-style: normal;
    font-weight: normal;
  }
  
  body {
    opacity: 0;
    font-family: ${({ theme }) => theme.font.medium};
    background-color: ${({ theme }) => theme.color.neutrals.neutral5};
  }

  button {
    border: none;
    background: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }

  a {
    cursor: pointer;
    color: ${({ theme }) => theme.color.black.black};
    text-decoration: none;
  }

  .cookie-consent-content {
    display: flex;
    justify-content: space-between;
  }
  .react-spring-bottom-sheet {
      --rsbs-backdrop-bg: rgba(0, 0, 0, 0.5);
      --rsbs-bg: white;
      --rsbs-handle-bg: hsla(0, 0%, 0%, 0.14);
  }

  [data-rsbs-header]:before {
      content: '';
      display: block;
      width: 71px !important; 
      height: 6px !important;
      background-color:#D9D9D9 !important;
      border-radius: 5px;
      margin: 8px auto !important;
  }
  
  .react-spring-bottom-sheet__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
  }

  .react-spring-bottom-sheet__content {
      padding: 16px;
  }

  .bottom-sheet-close-button {
      position: absolute;
      top: 5px;
      right: 16px;
      background: none;
      border: none;
      font-size: 40px;
      font-style: normal;
      font-weight: 200;
      line-height: normal;
      cursor: pointer;
      color: #262626;
      z-index: 200;
  }

  .bottom-sheet-close-button:focus {
      outline: none;
  }

  .bottom-sheet-content {
      padding: 48px 24px;
      ${({theme}) => theme.font_size.regular};
      .title {
          font-family: ${({theme}) => theme.font.medium500};
      }
      li {
          padding: 16px 0;
      } 
      p {
          ${({theme}) => theme.font_size.small};
      }
  }
  

`


export default GlobalStyles
